import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Agent attribution shortlink handler.
 * URL: /r/:code
 * 1. Log the click server-side (fire and forget).
 * 2. Set localStorage 'mv_ref' so downstream registration attributes to this agent.
 * 3. Redirect to home with ?ref=<code> for immediate visibility.
 */
export default function AgentReferralRedirect() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const c = (code || "").trim().toUpperCase();
    try {
      if (c) localStorage.setItem("mv_ref", c);
    } catch {}
    // Fire-and-forget click log
    if (c) {
      api.post("/marketing/log-click", {
        code: c,
        path: window.location.pathname,
        referrer: document.referrer || "",
        ua: navigator.userAgent || "",
      }).catch(() => {});
    }
    // Redirect after a tiny beat so the log request can leave.
    const t = setTimeout(() => {
      navigate(`/?ref=${encodeURIComponent(c)}`, { replace: true });
    }, 250);
    return () => clearTimeout(t);
  }, [code, navigate]);

  return (
    <main className="min-h-[60vh] flex items-center justify-center px-4" data-testid="agent-referral-redirect">
      <div className="text-center max-w-md">
        <div className="text-[11px] uppercase tracking-[0.28em]" style={{ color: "var(--mv-gold)" }}>§ Redirecting</div>
        <h1 className="font-display text-2xl md:text-3xl mv-green-text mt-3">One moment…</h1>
        <p className="mt-3 text-[14px]" style={{ color: "var(--mv-muted)" }}>
          You clicked a MAVULA agent link. Taking you to the site now.
        </p>
      </div>
    </main>
  );
}
